/**
 * Разделы панели — карта того, что она умеет, читаемая глазами. Экран, которого нет в этом
 * списке, для администратора не существует. Отдельный файл, а не экспорт из `Shell.tsx`:
 * компонентный модуль экспортирует только компоненты (fast refresh), а список нужен и тестам.
 */
export const sections = [
  { to: '/users', label: 'Пользователи' },
  { to: '/practices', label: 'Практики' },
  { to: '/yoga-styles', label: 'Справочник стилей' },
  { to: '/audit', label: 'Журнал аудита' },
] as const;
